import _ from 'lodash';
import * as actionTypes from '../../constants/actionTypes';
import * as helpers from "../../utilities/helpers";
import { parse } from 'event-stream';
import Cookies from 'cookies-js';

const initialState = {
  installationGroups: [],
  installationUnits: [],
  activeInstallationGroup: null
};

function loadState(state, {fabricator, installationGroups, installationUnits}) {
  state.fabricator = fabricator;
  state.installationGroups = installationGroups;
  state.installationUnits = installationUnits;
  if(state.activeInstallationGroup) {
    state.activeInstallationGroup = _.find(state.installationGroups, ig => ig.id == state.activeInstallationGroup.id);
  } else {
    let groupId = Cookies.get("selected-active-installation-id");
    state.activeInstallationGroup = _.find(state.installationGroups, ig => ig.id == groupId);
  }
  state.loaded = true;
  return state;
}

export default function installationReducer(state = initialState, action) {
  var newState = {...state};
  switch(action.type) {
    case actionTypes.Installation.DATA_LOADED:
      newState = loadState(newState, action.payload);
      break;
    case actionTypes.Installation.SET_ACTIVE_GROUP:
    //console.log('setting new active installation group', action.payload);
      newState.activeInstallationGroup = action.payload;
      Cookies.set("selected-active-installation-id", action.payload.id);
      Cookies.set("selected-active-installation-groupName", action.payload.customDisplayName || action.payload.featureGroup);
      break;
    case actionTypes.Installation.SAVE_INSTALLATION:
      let installGroups = [...newState.installationGroups];
      let igIndex = _.findIndex(installGroups, i => i.id == action.payload.installationGroupId);
      if(igIndex >= 0) {
        let index = _.findIndex(installGroups[igIndex].installations, n => n.id == data.id || (data.id == -1 && n.tempId == data.tempId));
        if(index >= 0) {
          installGroups[igIndex].installations[index] = {...action.payload};
        } else {
          installGroups[igIndex].installations.push({...action.payload});
        }
        installGroups[igIndex].installations = [...installGroups[igIndex].installations];
      }
      newState.installationGroups = [...installGroups];
      break;
  }
  //console.log('installation reducer new state', newState);
  return newState;
}